import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { PostHogProvider } from "posthog-js/react";
import { defineCustomElements } from "@ionic/pwa-elements/loader";
import posthog from "posthog-js";

import { App } from "./App";
import "./assets/styles/index.css";

import { mode, posthogApiHost, posthogKey } from "@/config/env";

defineCustomElements(window);

if (mode === "production") {
  posthog.init(posthogKey, { api_host: posthogApiHost, session_recording: { maskTextSelector: "*" } });
}

createRoot(document.getElementById("root")!).render(
  <PostHogProvider client={posthog}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </PostHogProvider>
);
